// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumCommentAdd__blockedNotice":"pr_a bii_sn bii_sv bii_sw bii_kx bii_ky bii_ke undefined bii_vt"};